module.exports = __webpack_public_path__ + "static/img/selection_6.9c96827c.png";